import React, { useState } from 'react';

import Modal from 'components/modal';

import ContactForm from 'components/contact-form';

let cb = null;

const withContactForm = () => Component => (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [transferId, setTransferId] = useState(null);
    const [loading, setLoading] = useState(false);

    const _onSubmit = async (props = {}) => {
        if (cb) {
            setLoading(true)

            await cb(props)
            setLoading(false)

            setIsOpen(false);
        }
    }

    const openContactForm = ({ transferId } = {}, onSubmit) => {
        setTransferId(transferId)

        cb = onSubmit;
        if (transferId) setIsOpen(true);
    }

    const closeConfirm = (error) => {
        setIsOpen(false)
    };

    return (
        <>
            <Component
                {...props}
                openContactForm={openContactForm}
            />
            <div>
                <Modal
                    isOpen={isOpen}
                    onRequestClose={closeConfirm}
                    className='withContactForm'
                >
                    <div className='withContactForm__modal'>
                        <ContactForm loading={loading} transferId={transferId} onSubmit={_onSubmit}/>
                    </div>
                </Modal>
            </div>
        </>
    )
};

export default withContactForm;